<template lang="pug">
  .container-verifier-2(v-loading="loading", :element-loading-fullscreen="false")
    el-dialog(:visible.sync="showMethodSelect", title="用户身份验证",
      :close-on-click-modal="false", :close-on-press-escape="false", append-to-body, :custom-class="customClass")
      el-form(:model="source", :label-position="labelPosition", label-width="150px")
        el-form-item(label="选择验证方式")
          el-select(v-model="source.verify_method")
            el-option(value="BY_PHONE", label="手机号码")
            el-option(value="BY_EMAIL", label="邮箱地址")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="next()") 下一步
        el-button(@click="abort()") 取消

    el-dialog(:visible.sync="showPhoneVerify", title="用户手机验证",
      :close-on-click-modal="false", :close-on-press-escape="false", append-to-body, :custom-class="customClass")
      el-form(:model="source", :label-position="labelPosition", label-width="150px", v-if="!isMobile")
        el-form-item(label="手机号码") {{ source.identifier }}
        el-form-item(label="输入图形验证码")
          .captcha-container(v-loading="captchaLoading", :element-loading-fullscreen="false")
            el-input(v-model="source.captcha").captcha-input
            img(:src="captcha_url", @click="getCaptcha", title="点击更换图形验证码").captcha
        el-form-item(label="输入短信验证码")
          .verify-code-container(v-loading="verifyLoading", :element-loading-fullscreen="false")
            el-input(v-model="source.user_verify_code")
              el-button(slot="append", @click="sendVerifyCode", :disabled="countdown \> 0")
                template(v-if="!verify_locked") 获取
                template(v-else) {{ countdown }} s
      template(v-else)
        .data-block(v-loading="captchaLoading", :element-loading-fullscreen="false")
          data-row(label="手机号码") {{ source.identifier }}
          data-row(label="图形验证码")
            el-input(v-model="source.captcha")
          data-row(label="点击更换验证码")
            img(:src="captcha_url", @click="getCaptcha", title="点击更换验证码").captcha
        .data-block(v-loading="verifyLoading", :element-loading-fullscreen="false")
          data-row(label="短信验证码")
            el-input(v-model="source.user_verify_code")
          data-row(label="")
            el-button(type="primary", @click="sendVerifyCode", :disabled="countdown \> 0")
              template(v-if="!verify_locked") 获取
              template(v-else) {{ countdown }} s
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="verify()") 确定
        el-button(@click="abort()") 取消
    
    el-dialog(:visible.sync="showPhoneBinding", title="用户手机绑定", 
      :close-on-click-modal="false", :close-on-press-escape="false", append-to-body, :custom-class="customClass")
      el-form(:model="source", :label-position="labelPosition", label-width="150px", v-if="!isMobile")
        el-form-item(label="手机号码")
          el-input(v-model="source.resp_per_telephone_no")
        el-form-item(label="输入图形验证码")
          .captcha-container(v-loading="captchaLoading", :element-loading-fullscreen="false")
            el-input(v-model="source.captcha").captcha-input
            img(:src="captcha_url", @click="getCaptcha", title="点击更换图形验证码").captcha
        el-form-item(label="输入短信验证码")
          .verify-code-container(v-loading="verifyLoading", :element-loading-fullscreen="false")
            el-input(v-model="source.user_verify_code")
              el-button(slot="append", @click="sendVerifyCode", :disabled="countdown \> 0")
                template(v-if="!verify_locked") 获取
                template(v-else) {{ countdown }} s
      template(v-else)
        .data-block(v-loading="captchaLoading", :element-loading-fullscreen="false")
          data-row(label="手机号码")
            el-input(v-model="source.resp_per_telephone_no")
          data-row(label="图形验证码")
            el-input(v-model="source.captcha")
          data-row(label="", v-loading="captchaLoading",  :element-loading-fullscreen="false")
            img(:src="captcha_url", @click="getCaptcha", title="点击更换图形验证码").captcha
        .data-block(v-loading="verifyLoading", :element-loading-fullscreen="false")
          data-row(label="短信验证码")
            el-input(v-model="source.user_verify_code")
          data-row(label="")
            el-button(type="primary", @click="sendVerifyCode", :disabled="countdown \> 0")
              template(v-if="!verify_locked") 获取
              template(v-else) {{ countdown }} s
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="binding()") 绑定
        el-button(@click="abort()") 取消

    el-dialog(:visible.sync="showEmailVerify", title="用户邮箱验证",
      :close-on-click-modal="false", :close-on-press-escape="false", append-to-body, :custom-class="customClass")
      el-form(:model="source", :label-position="labelPosition", label-width="150px", v-if="!isMobile")
        el-form-item(label="邮箱地址")
          .captcha-container
            .display-block {{ source.identifier }}
            el-button(@click="sendVerifyCode", :disabled="countdown \> 0").display-block
              template(v-if="!verify_locked") 获取验证码
              template(v-else) {{ countdown }} s
        el-form-item(label="输入验证码")
          el-input(v-model="source.user_verify_code")
      template(v-else)
        .data-block
          data-row(label="邮箱地址") {{ source.identifier }}
          data-row(label="")
            el-button(type="primary", @click="sendVerifyCode", :disabled="countdown \> 0")
              template(v-if="!verify_locked") 获取验证码
              template(v-else) {{ countdown }} s
        .data-block
          data-row(label="验证码")
            el-input(v-model="source.user_verify_code")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="verify()") 确定
        el-button(@click="abort()") 取消
    
    el-dialog(:visible.sync="showEmailBinding", title="用户邮箱绑定",
      :close-on-click-modal="false", :close-on-press-escape="false", append-to-body, :custom-class="customClass")
      el-form(:model="source", :label-position="labelPosition", label-width="150px", v-if="!isMobile")
        el-form-item(label="邮箱地址")
          el-input(v-model="source.resp_per_email")
            el-button(slot="append", @click="sendVerifyCode", :disabled="countdown \> 0")
              template(v-if="!verify_locked") 获取验证码
              template(v-else) {{ countdown }} s
        el-form-item(label="输入验证码")
          el-input(v-model="source.user_verify_code")
      template(v-else)
        .data-block
          data-row(label="邮箱地址")
            el-input(v-model="source.resp_per_email")
          data-row(label="")
            el-button(type="primary", @click="sendVerifyCode", :disabled="countdown \> 0")
              template(v-if="!verify_locked") 获取验证码
              template(v-else) {{ countdown }} s
        .data-block
          data-row(label="验证码")
            el-input(v-model="source.user_verify_code")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="binding()") 绑定
        el-button(@click="abort()") 取消
</template>

<script>
import ProtocalError from '@/vuex/protocalError';
// Events:
// @success
// @abort

export default {
  props: {
    scene: {
      type:     String,
      default:  null,
    },
    opt: {
      type:     String,
      default:  null,
    },
    login_name: {
      type:     String,
      default:  null,
    },
    outer_identifier: {
      type:     String,
      default:  null,
    },
    isBinding: {
      type:     Boolean,
      default:  false,
    },
    isModify: {
      type:     Boolean,
      default:  false,
    },
    method: {   // When being binding/modify, it's required.
      type:     String,
      default:  null,
    },
  },
  data () {
    return {
      showMethodSelect:     false,

      showPhoneVerify:      false,
      showEmailVerify:      false,

      showPhoneBinding:     false,
      showEmailBinding:     false,

      source:   {
        verify_method:      'BY_PHONE',   // 'BY_PHONE', 'BY_EMAIL'

        biz_ticket:         null,
        captcha:            null,
        user_verify_code:   null,
        identifier:         null,

        resp_per_telephone_no:  null,
        resp_per_email:         null,
      },
      biz_ticket:       null, // only for modifying phone/email.

      captcha_url:      null,

      loading:        false,
      captchaLoading: false,
      verifyLoading:  false,
      verify_locked:  false,
      countdown:      -1,
    };
  },
  computed: {
    isMobile () {
      return window.browserInfo.isMobile;
    },
    labelPosition () {
      return this.isMobile ? 'top' : 'right';
    },
    customClass () {
      let baseClass = 'app-container container-verifier-2';
      return `${baseClass}${this.isMobile ? ' container-verifier-mobile' : ''}`;
    },
  },
  methods: {
    next () {
      if (!this.scene) {
        this.$message({
          type:     'error',
          message:  `未配置验证场景`,
        });
        return;
      }
      if (!this.opt) {
        this.$message({
          type:     'error',
          message:  `未配置操作类型`,
        });
        return;
      }

      this.loading = true;
      const params = {
        verify_method:  this.source.verify_method,
        scene:          this.scene,
        opt:            this.opt,
        login_name:     this.login_name || null,
        biz_ticket:     this.biz_ticket || null,
      };
      this.$store.dispatch('START_VERIFY', params).then(({ biz_ticket, identifier }) => {
        this.source.biz_ticket = biz_ticket;
        this.source.identifier = identifier || null;
        this.showMethodSelect = false;

        this.getCaptcha();

        if (this.isBinding || this.isModify) {
          const method = this.method.toUpperCase();
          if (!method) {
            this.$message({
              type:     'success',
              message:  '绑定方式配置错误',
            });
            return;
          }

          if (method === 'PHONE') {
            this.showPhoneBinding = true;
          } else if (method === 'EMAIL') {
            this.showEmailBinding = true;
          }
        } else {
          const verify_method = this.source.verify_method;
          if (verify_method === 'BY_PHONE') {
            this.showPhoneVerify = true;
          } else if (verify_method === 'BY_EMAIL') {
            this.showEmailVerify = true;
          }
        }
      }).catch(({ code, msg }) => {
        if (code === 43001 || code === 42104) {
          const hint = this.source.verify_method === 'BY_PHONE' ? '您还没在商家资料中绑定手机号' : '您还没在商家资料中绑定邮箱';
          this.$alert(`${hint}`, {
            type:         'warning',
            customClass:  'verifier-confirm-box',
          }).then(() => {
            if (this.$route.path !== '/') {
              this.$router.push('/');
            }
          });
        } else {
          this.$message({
            type:     'error',
            message:  `用户验证初始化失败。${code}：${msg}`,
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },

    getCaptcha () {
      this.captchaLoading = true;
      return this.$store.dispatch('GET_CAPTCHA', this.source.biz_ticket).then(({ captcha_url }) => {
        this.source.captcha = null;
        this.captcha_url = captcha_url;
        return captcha_url;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取图形验证码失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.captchaLoading = false;
      });
    },

    startCountdown () {
      this.countdown = 60;
      this.verify_locked = true;
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.verify_locked = false;
          clearInterval(t);
        }
      }, 1000);
    },
    endCountdown () {
      this.countdown = -1;
    },

    sendVerifyCode () { // Send Code through SMS or Email
      const verify_method = this.source.verify_method;
      const captcha = this.source.captcha;
      const biz_ticket = this.source.biz_ticket;
      let outer_identifier = this.outer_identifier;

      if (verify_method === 'BY_PHONE' && !captcha) {
        this.$message({
          type:     'warning',
          message:  `请先输入图形验证码以获取手机验证码`,
        });
        return;
      }
      
      if (this.isBinding || this.isModify) {
        if (verify_method === 'BY_PHONE') {
          if (!this.source.resp_per_telephone_no || !this.$regex.phoneRegex.test(this.source.resp_per_telephone_no)) {
            this.$message({
              type:     'warning',
              message:  `请输入有效的手机号码`,
            });
            return;
          } else {
            outer_identifier = this.source.resp_per_telephone_no;
          }
        } else if (verify_method === 'BY_EMAIL') {
          if (!this.source.resp_per_email || !this.$regex.emailRegex.test(this.source.resp_per_email)) {
            this.$message({
              type:     'warning',
              message:  `请输入有效的邮箱地址`,
            });
            return;
          } else {
            outer_identifier = this.source.resp_per_email;
          }
        }
      }

      const params = { captcha, biz_ticket, outer_identifier };

      this.verifyLoading = true;
      this.$store.dispatch('SEND_VERIFY_CODE', params).then(() => {
        this.startCountdown();
        this.$message({
          type:     'success',
          message:  '验证码已发出，请注意查收',
        });
      }).catch(({ code, msg }) => {
        if (code === 1004) {
          this.$message({
            type:     'error',
            message:  `验证码发送失败。${verify_method === 'BY_PHONE' ? '手机号码' : '邮箱地址'}无效。`,
          });
        } else {
          this.$message({
            type:     'error',
            message:  `验证码发送失败。${code}：${msg}`,
          });
          if (code === 43002) {
            this.source.captcha = null;
            this.getCaptcha();
          }
        }
      }).finally(() => {
        this.verifyLoading = false;
      });
    },

    verify () {
      const verify_method = this.source.verify_method;
      if (verify_method === 'BY_PHONE') {
        if (!this.source.captcha) {
          this.$message({
            type:     'warning',
            message:  `请输入有效的图形验证码`,
          });
          return Promise.reject(new ProtocalError(0, `请输入有效的图形验证码`));
        }
        if (!this.source.user_verify_code) {
          this.$message({
            type:     'warning',
            message:  `请输入短信验证码`,
          });
          return Promise.reject(new ProtocalError(0, `请输入短信验证码`));
        }
      } else if (verify_method === 'BY_EMAIL') {
        if (!this.source.user_verify_code) {
          this.$message({
            type:     'warning',
            message:  `请输入邮件验证码`,
          });
          return Promise.reject(new ProtocalError(0, `请输入邮件验证码`));
        }
      }

      const params = {
        user_verify_code: this.source.user_verify_code,
        biz_ticket:       this.source.biz_ticket,
      };

      this.loading = true;
      return this.$store.dispatch('IDENTITY_VERIFY', params).then(() => {
        const biz_ticket = this.source.biz_ticket;
        this.$emit('success_verify', biz_ticket);

        if (!this.isModify && !this.isBinding) {
          this.$message({
            type:     'success',
            message:  '身份已验证成功',
          });

          this.clearAll();
          this.closeAll();
        }
        return biz_ticket;
      }).catch(({ code, msg }) => {
        if (code === 43012) {
          this.$message({
            type:     'error',
            message:  `验证码校验失败。请重新获取${this.source.verify_method === 'BY_PHONE' ? '短信' : '邮件'}验证码。`,
          });
        } else {
          this.$message({
            type:     'error',
            message:  `身份验证失败。${code}：${msg}`,
          });
        }
        return Promise.reject(new ProtocalError(code, msg));
      }).finally(() => {
        this.loading = false;
      });
    },

    binding () {
      return this.verify().then(() => {
        const verify_method = this.source.verify_method;
        let method = '';
        let outer_identifier = '';

        if (verify_method === 'BY_PHONE') {
          if (!this.source.resp_per_telephone_no || !this.$regex.phoneRegex.test(this.source.resp_per_telephone_no)) {
            this.$message({
              type:     'warning',
              message:  `请输入有效的手机号码`,
            });
            return;
          } else {
            method = this.isModify ? 'MODIFY_PHONE' : 'BIND_PHONE';
            outer_identifier = this.source.resp_per_telephone_no;
          }
        } else if (verify_method === 'BY_EMAIL') {
          if (!this.source.resp_per_email || !this.$regex.emailRegex.test(this.source.resp_per_email)) {
            this.$message({
              type:     'warning',
              message:  `请输入有效的邮箱地址`,
            });
            return;
          } else {
            method = this.isModify ? 'MODIFY_EMAIL' : 'BIND_EMAIL';
            outer_identifier = this.source.resp_per_email;
          }
        }

        const params = Object.assign({}, this.source, {
          outer_identifier,
        });

        this.loading = true;
        return this.$store.dispatch(method, params).then((data) => {
          this.$emit('success_bind', outer_identifier);
          this.$message({
            type:     'success',
            message:  '绑定成功',
          });

          this.clearAll();
          this.closeAll();
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `绑定失败。${code}：${msg}`,
          });
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {

      });
    },

    abort () {
      this.$confirm('是否确认终止用户信息认证流程？', '提示', {
        customClass:  'verifier-confirm-box',
      }).then(() => {
        this.$emit('abort');
        this.endCountdown();
        this.clearAll();
        this.closeAll();
      }).catch(() => {

      });
    },

    clearAll () {
      this.source = {
        verify_method:      'BY_PHONE',   // 'BY_PHONE', 'BY_EMAIL'

        biz_ticket:         null,
        captcha:            null,
        user_verify_code:   null,
        identifier:         null,

        resp_per_telephone_no:  null,
        resp_per_email:         null,
      };
      this.captcha_url = false;
      this.loading = false;
    },
    closeAll () {
      this.showMethodSelect = false;

      this.showPhoneVerify = false;
      this.showEmailVerify = false;
      this.showPhoneBinding = false;
      this.showEmailBinding = false;
    },

    init (biz_ticket = null) {
      console.log(`init,${biz_ticket}`)
      this.clearAll();
      this.closeAll();
      this.biz_ticket = biz_ticket;

      if ((this.isBinding || this.isModify) && typeof this.method === 'string') {
        const method = this.method.toUpperCase();
        if (method === 'PHONE' || method === 'EMAIL') {
          this.source.verify_method = `BY_${method}`;   //  BY_PHONE or BY_EMAIL
          this.next();
        } else {
          this.$message({
            type:     'success',
            message:  '未配置绑定方式或配置错误',
          });
        }
      } else {
        this.showMethodSelect = true;
      }
    },
  },
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-verifier-2 {
  height:   auto;
  .captcha-container, .verify-code-container {
    .flex(center, space-between, row);
  }

  .captcha {
    .display-block;
    .cursor-pointer;

    height:   32px;
    padding-left:   8px;
  }
  .captcha-input {
    flex:   1;
  }
}

.verifier-confirm-box {
  @media screen and (max-width: 500px) {
    width:  auto;
  }
}

.container-verifier-mobile {
  width:  100%;

  .el-dialog__header {
    padding:  15px 20px 10px;
  }

  .el-dialog__body {
    padding:  20px 0;
    background:   @background-grey-2;
  }
}
</style>
